<template>
  <div v-if="type === 'beneficiaries'">
    <template v-if="!loading">
      <template v-for="(tab, i) in tabs">
        <transition :key="`fade${i}`" name="fade">
          <div v-if="!segment || (selected === i)" class="bene_view mt-2 mb-4" role="tablist">
            <!-- <h3 class="text-dark mb-2">{{ tab.name }}</h3> -->
            <ArticleList
              :heading="tab.name"
              :type="type"
              :osc_year="osc_year"
              :segment="replaceSpaces(tab.key)"
              :endpoint="tab.url"
            />
          </div>
        </transition>
      </template>
    </template>
  </div>
  <b-tabs v-else v-model="selected">
    <b-tab v-for="(tab, i) in tabs" :id="`tab_${i}`" :key="`tab${i}`">
      <template slot="title">{{ tab.name }}</template>
      <ArticleList
        v-if="selected === i"
        :type="type"
        :segment="replaceSpaces(tab.key)"
        :endpoint="tab.url"
      />
    </b-tab>
  </b-tabs>
</template>
<script>
import ArticleList from "@/components/ArticleList.vue";
import * as _ from "lodash";

export default {
  name: "Tabs",
  components: { ArticleList },
  props: ["type", "segment", "tab_menus", "osc_year"],
  data() {
    let selected = 0;
    let tabs = [];

    if (this.tab_menus) {
      let __this = this;
      this.tab_menus.forEach(function(item) {
        var url = item.url.startsWith("/") ? item.url.substr(1) : item.url;
        var key = url.replace(__this.type + "/", "");
        if (key === __this.segment) {
          selected = tabs.length;
        }
        // console.log(key);
        tabs.push({
          key: key,
          url: __this.getLink(__this.type, key),
          name: item.name,
          items: null
        });
      });
    }
    return {
      loading: false,
      selected: selected,
      tabs: tabs
    };
  },
  watch: {
    segment(val) {
      let key = val;
      if (this.osc_year) {
        key += "/" + this.osc_year;
      }
      // console.log(key);
      this.selected = _.findIndex(this.tabs, { key: key });
    },
    osc_year(val) {
      let key = this.segment;
      if (val) {
        key += "/" + val;
      }
      // console.log(key);
      this.selected = _.findIndex(this.tabs, { key: key });
    },
    //eslint-disable-next-line
    selected(val) {
      if (this.type === "beneficiaries") {
        this.refresh();
      } else if (
        this.tabs[this.selected] &&
        this.segment != this.tabs[this.selected].key
      ) {
        this.updatePath();
      }
      // if (this.type === "beneficiaries") {
      //   this.refresh();
      // } else if (val != null) {
      //   this.updatePath();
      // }
    }
  },
  mounted() {
    this.updatePath();
  },
  methods: {
    getLink(parent, child) {
      var new_url = "/" + parent + "/list/" + child;
      new_url = new_url.replace("//+/g", "/");
      return new_url;
    },
    updatePath() {
      if (this.type === "beneficiaries") return;
      var activeTab = this.tabs[this.selected];
      this.$router.replace(activeTab.url.replace("/list", ""));
    },
    replaceSpaces(str) {
      return str ? str.replace(/\s+/g, "_") : "";
    },
    refresh() {
      this.loading = true;
      this.$nextTick(() => {
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="scss" src="../assets/scss/tabs.scss"></style>